export const dropdownClicked = () => ({
  type: 'Clicked Feeding Guidelines Recipe Dropdown',
});
